var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalfprice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABYlBMVEXkBhPoJC/mGiboLzrz lZr2rbH4vcDyhYv86er1oabyipD////4xcj3trr61Nb85+j1oqf98PH1pqrkCBX719nmFiL96er4 xMf+9vf85ebsU1v0mZ7+8vLweYDqQkzpNkH5zdD619noLTj//f31qa3nJTD84eLsT1j97u/lEx/4 vMD96+z97O3//PzzjpTuZGzoKjX0m6DqP0n97e797/DpN0LrS1TnJjHkBxTpPUfoLDfpN0HsUFnn Iy/pPUjnJzP2rLD+8vP96uv60tXlFSHxhIrrT1jlEBztWWHxe4HrTFbsV2DuZ27qQkvsUVrqRE7m HSjwe4LlDxz4vsHvcnn+9PT84uPuaHD6z9HxgonuYmv+9fXxhIvpPEb5zM/zkJbyjZP2sLTtV2D+ 8/PuZ2/2srbmHSn6ztD84OH4v8LtXmf+9/fwdXz0mJ3zkJX71tjsVFzwc3rnIi7va3P85OXuY2v7 hRD8AAAAAWJLR0QLH9fEwAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+QJEA45E5ysJ7QA AADtSURBVCjPY2AYnICRiYGBmRnOZWFlYGBjh7A5OBm4uHngUrx8DAz8AnApQSFhhJSIqKiYgLC4 hKQUUEqaW0YWIcUNBAIMcvIKikApJWUVVYSUmrq6hoCmlqC2DshAXT0GNLv0uQ0McUgZKfMZm6BL mZqZW1haMVjb2Mox2FkxyNkjpBwcnZxdgLSrG0YIOAi4S3h4enn7+DL46fkHuAYGIaSCQ5StQ8PC IyKjomNi4+KDExBSkolJDMkpDBGRqUIMadzpGZlIBgKJ5CyglKGialp2DrMBXCo3D0jkFzDwFhaJ Oxbrl2iUDnT8EwcAEZMkekWxKN8AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDktMTZUMTQ6NTc6 MTkrMDI6MDA77uiVAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA5LTE2VDE0OjU3OjE5KzAyOjAw SrNQKQAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfprice);
export default __webpack_public_path__ + "static/media/Halfprice.2658eeb8370fdccacbe03f258113dafd.svg";
export { ForwardRef as ReactComponent };